import React, { forwardRef } from "react";

import { cn } from "./cn";

/* ── Input component ─────────────────────────────────────── */

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error = false, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={cn(
          "h-10 w-full rounded-lg border bg-surface px-3 text-sm text-ink placeholder:text-ink-faint input-glow transition-colors",
          "ds-control",
          error ? "border-red-500" : "border-edge",
          className,
        )}
        aria-invalid={error || undefined}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";

export { Input };
export type { InputProps };
